/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {registerProps as ɵb} from './table-action/table-action.props';
export {registerProps as ɵc} from './table-column-group/table-column-group.props';
export {registerProps as ɵd} from './table-column/table-column.props';
export {registerProps as ɵf} from './table-row-action/table-row-action.props';
export {registerProps as ɵe} from './table-row/table-row.props';
export {registerProps as ɵa} from './table.props';